// The bank-return page shows "Bank account added" only to the tab that started a bank setup for that company.
// The provider still decides whether the bank is ready; this only stops the page from greeting anyone who opens it.

const KEY = 'pr_bank_setup_company'

/** Call right before sending the user to the hosted bank form. */
export function startBankSetup(companyId: string): void {
  try {
    window.sessionStorage.setItem(KEY, companyId)
  } catch {
    // storage blocked: the return page sends the user to /
  }
}

export function bankSetupStarted(companyId: string): boolean {
  try {
    return window.sessionStorage.getItem(KEY) === companyId
  } catch {
    return false
  }
}

export function endBankSetup(): void {
  try {
    window.sessionStorage.removeItem(KEY)
  } catch {
    // nothing to clear
  }
}
